import type {
  ReaderContent,
  ReaderGlossaryEntry,
  ReaderToken
} from '@/types/reader'
import type { SearchResult } from '@/types/dictionary'

export function searchResultToGlossaryEntry(
  result: SearchResult
): ReaderGlossaryEntry {
  return {
    id: result.id,
    simplified: result.simplified,
    traditional: result.traditional,
    pinyin: result.pinyin,
    zhuyin: result.zhuyin,
    definitions: result.definitions?.length
      ? result.definitions.slice(0, 4)
      : result.preview
        ? [result.preview]
        : [],
    hsk: result.hsk ?? null,
    tocfl: result.tocfl ?? null,
    frequency: result.frequency ?? null
  }
}

export function buildGlossaryFromTokens(
  tokens: ReaderToken[],
  lookup: Map<number, ReaderGlossaryEntry>
) {
  const glossary: Record<string, ReaderGlossaryEntry> = {}

  for (const token of tokens) {
    if (!token.entryId) continue
    const entry = lookup.get(token.entryId)
    if (entry) {
      glossary[String(entry.id)] = entry
    }
  }

  return glossary
}

export function mergeGlossaries(
  ...glossaries: Array<Record<string, ReaderGlossaryEntry> | undefined>
) {
  const merged: Record<string, ReaderGlossaryEntry> = {}

  for (const glossary of glossaries) {
    if (!glossary) continue
    Object.assign(merged, glossary)
  }

  return merged
}

export function getReaderEntry(
  content: ReaderContent,
  entryId: number | undefined
) {
  if (!entryId) return null
  return content.glossary[String(entryId)] ?? null
}
